export default __webpack_public_path__ + "static/media/clough_thumb.f4cbbb1e.jpg";